module.exports = __webpack_public_path__ + "img/waitTime.77e4dd92.svg";